import React, { useState, useEffect, useContext, useMemo } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
// eslint-disable-next-line no-unused-vars
import { findUpper } from "../../../utils/Utils";
import { filterRole, filterStatus, countryOptions } from "./UserData";
import moment from "moment";
import swal from "sweetalert";

import {
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
  Alert,
} from "reactstrap";
import { meCan } from "../../../utils/adminPermissions";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Col,
  // eslint-disable-next-line no-unused-vars
  UserAvatar,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
  TooltipComponent,
} from "../../../components/Component";
// eslint-disable-next-line no-unused-vars
import Select from "react-select";
// eslint-disable-next-line no-unused-vars
import { Link, useHistory, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { UserContext } from "./UserContext";
// eslint-disable-next-line no-unused-vars
import { bulkActionOptions } from "../../../utils/Utils";
import axios from "axios";
import { API_BASE_URL, getPublicUrl } from "../../../utils/Utils";
import ConfirmModal from "../../../components/partials/user-manage/ConfirmModal";
import { isAbortError } from "../../../utils/asyncRequestGuards";
import AdminSideDrawer from "../../../components/admin/AdminSideDrawer";

function displayParts(...parts) {
  return parts
    .filter((p) => p != null && String(p).trim() !== "")
    .map((p) => String(p).trim())
    .join(" ");
}

/**
 * Single source for table display and any client-side ordering hints.
 * Server-side name sort uses `last_name,first_name` (see sort cycle for Display name column).
 */
function formatUserListFullName(item) {
  const line = displayParts(item?.salutation, item?.first_name, item?.last_name);
  return line || item?.email || "—";
}

const USER_LIST_SORT = {
  nameAsc: "last_name,first_name",
  nameDesc: "-last_name,-first_name",
  emailAsc: "email",
  emailDesc: "-email",
  phoneAsc: "phone",
  phoneDesc: "-phone",
  roleAsc: "role",
  roleDesc: "-role",
  dateAsc: "createdAt",
  dateDesc: "-createdAt",
};

function sortCaret(active, asc, desc) {
  if (active === asc) return " ↑";
  if (active === desc) return " ↓";
  return "";
}

/** DB: country_code + phone separate; UI: one readable string + optional tel: link */
function formatUserListPhone(item) {
  const cc = item?.country_code != null ? String(item.country_code).trim() : "";
  const raw = item?.phone != null ? String(item.phone).trim() : "";
  if (!cc && !raw) return { text: "—", href: null };
  if (raw.startsWith("+")) {
    const href = raw.replace(/\s/g, "");
    return { text: raw, href };
  }
  const text = displayParts(cc, raw) || "—";
  const digits = `${cc.replace(/\D/g, "")}${raw.replace(/\D/g, "")}`;
  const href = digits ? `+${digits.replace(/^\+/, "")}` : null;
  return { text, href };
}

function displayScalar(v) {
  if (v == null || String(v).trim() === "") return "—";
  return String(v);
}

function medicalPartnerIdFromUser(item) {
  const ref = item?.medicalPartnerId;
  if (ref == null) return null;
  if (typeof ref === "object" && ref._id != null) return String(ref._id);
  return String(ref);
}

function medicalPartnerLabelFromUser(item) {
  const ref = item?.medicalPartnerId;
  if (ref && typeof ref === "object" && ref.organization_name != null) {
    const o = String(ref.organization_name).trim();
    return o || null;
  }
  return null;
}

const UserListCompact = () => {
  const history = useHistory();
  const location = useLocation();
  const canDeleteUser = meCan("directory.user_delete.act");
  const userListQueryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const out = {};
    const role = params.get("role")?.trim();
    if (role) out.role = role;
    const team = params.get("team")?.trim();
    if (team) out.team = team;
    const journey = params.get("journey")?.trim();
    if (journey) out.journey = journey;
    const segment = params.get("segment")?.trim();
    if (segment) out.segment = segment;
    const sort = params.get("sort")?.trim();
    if (sort) out.sort = sort;
    return out;
  }, [location.search]);
  const journeyParam = useMemo(
    () => new URLSearchParams(location.search).get("journey")?.trim() || "",
    [location.search]
  );
  const segmentParam = useMemo(
    () => new URLSearchParams(location.search).get("segment")?.trim() || "",
    [location.search]
  );
  const activeSortParam = useMemo(
    () => new URLSearchParams(location.search).get("sort")?.trim() || "",
    [location.search]
  );
  const teamOnly =
    userListQueryParams.team === "1" ||
    String(userListQueryParams.team || "").toLowerCase() === "true";
  const patientsOnly = !teamOnly && userListQueryParams.role === "client";

  const { contextData } = useContext(UserContext);
  const [data, setData] = contextData;

  // eslint-disable-next-line no-unused-vars
  const [sm, updateSm] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [tablesm, updateTableSm] = useState(false);
  const [onSearch, setonSearch] = useState(true); // onSearch is used (line 392, 446)
  const [onSearchText, setSearchText] = useState("");
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    _id: "",
    email: "",
    phone: "",
    salutation: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    address: "",
    role: "",
    country_code: "",
    status: { value: "active", label: "Active" },
    createdAt: "",
    medicalPartnerId: null,
    medicalPartnerName: null,
  });
  // eslint-disable-next-line no-unused-vars
  const [actionText, setActionText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [itemPerPage, setItemPerPage] = useState(10);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [submittedData, setSubmitData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [errorVal, setError] = useState("");
  const [userList, setUserList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [quote, setQuote] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(localStorage.getItem("accessToken"));
  const [showConfirmModal, setShowConfirmModal] = useState({
    isOpen: false,
    type: null, // "deleteUser"
    user: null,
    onConfirm: null,
  });
  const [patientDrawerUser, setPatientDrawerUser] = useState(null);
  const [patientDrawerLoading, setPatientDrawerLoading] = useState(false);
  const [patientConsultations, setPatientConsultations] = useState([]);
  const [patientQuotes, setPatientQuotes] = useState([]);

  const cycleSortQuery = (ascValue, descValue) => {
    const params = new URLSearchParams(location.search);
    const cur = params.get("sort")?.trim() || "";
    if (cur === ascValue) params.set("sort", descValue);
    else if (cur === descValue) params.set("sort", ascValue);
    else params.set("sort", ascValue);
    const qs = params.toString();
    history.push({ pathname: location.pathname, search: qs ? `?${qs}` : "" });
  };

  useEffect(() => {
    const ac = new AbortController();
    axios
      .get(`${API_BASE_URL}/api/v1/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: userListQueryParams,
        signal: ac.signal,
      })
      .then((response) => {
        const rows = response.data.data || [];
        setUserList(rows);
        setData(rows);
      })
      .catch((err) => {
        if (!isAbortError(err)) {
          setUserList([]);
          setData([]);
        }
      });
    return () => ac.abort();
  }, [token, userListQueryParams, setData]);

  useEffect(() => {
    setCurrentPage(1);
  }, [location.search]);

  // Client-side filter on current result set (always derived from `data` from API)
  useEffect(() => {
    if (onSearchText !== "") {
      const q = onSearchText.toLowerCase();
      const filteredObject = data.filter((item) => {
        const email = item.email != null ? String(item.email).toLowerCase() : "";
        const name = formatUserListFullName(item).toLowerCase();
        return email.includes(q) || name.includes(q);
      });
      setUserList(filteredObject);
    } else {
      setUserList([...data]);
    }
  }, [onSearchText, data]);

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to reset the form
  const resetForm = () => {
    setFormData({
      _id: "",
      email: "",
      phone: "",
      salutation: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      address: "",
      role: "",
      status: "active",
      country_code: "",
      createdAt: "",
      medicalPartnerId: null,
      medicalPartnerName: null,
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  // submit function to update a new item
  const onEditSubmit = (submitData) => {
    setLoading(true);
    // const { name, email, phone } = submitData;
    let submittedData;
    let newitems = userList;
    newitems.forEach((item) => {
      if (item._id === editId) {
        submittedData = {
          salutation: formData.salutation,
          first_name: submitData.first_name,
          last_name: submitData.last_name,
          email: submitData.email,
          country_code: formData.country_code,
          phone: submitData.phone,
          role: formData.role,
        };
      }
    });
    console.log(submittedData);
    axios
      .put(`${API_BASE_URL}/api/v1/user/${editId}`, submittedData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response);
        setModal({ edit: false });
        // window.location.reload(false);
        resetForm();
        axios
          .get(`${API_BASE_URL}/api/v1/user`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: userListQueryParams,
          })
          .then((response) => {
            const rows = response.data.data || [];
            setUserList(rows);
            setData(rows);
          });
        swal("Success", "User updated successfully", "success");
      })
      .catch(function (error) {
        swal("Opps!", "An error has occured", "warning");
        console.log(error.message);
        setTimeout(() => {
          setError(error.message);
          setLoading(false);
        }, 2000);
      });
  };

  // function that loads the want to editted data
  const onAddSubmit = (submitData) => {
    console.log("add", submitData);
    setLoading(true);
    // setModal({ add: false });

    let submittedData = {
      salutation: formData.salutation,
      first_name: submitData.first_name,
      last_name: submitData.last_name,
      email: submitData.email,
      country_code: formData.country_code,
      phone: submitData.phone,
      role: formData.role,
    };

    console.log("submit data", submittedData);

    axios
      .post(`${API_BASE_URL}/api/v1/user`, submittedData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response);
        setModal({ add: false });
        // window.location.reload(false);

        axios
          .get(`${API_BASE_URL}/api/v1/user`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: userListQueryParams,
          })
          .then((response) => {
            const rows = response.data.data || [];
            setUserList(rows);
            setData(rows);
          });
        swal("Good job!", "User added successfully", "success");
      })
      .catch(function (error) {
        setModal({ add: false });
        swal("Opps!", "An error has occured", "warning");
        console.log(error.message);
        setTimeout(() => {
          setError(error.message);
          setLoading(false);
        }, 2000);
      });
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    console.log("edit", id);
    userList.forEach((item) => {
      if (item._id === id) {
        setFormData({
          _id: item._id,
          email: item.email,
          phone: item.phone,
          salutation: item.salutation,
          first_name: item.first_name,
          middle_name: item.middle_name,
          last_name: item.last_name,
          address: item.address,
          role: item.role,
          status: item.status,
          country_code: item.country_code,
          createdAt: item.createdAt,
          medicalPartnerId: medicalPartnerIdFromUser(item),
          medicalPartnerName: medicalPartnerLabelFromUser(item),
        });
        setModal({ edit: true }, { add: false });
        setEditedId(item._id);
      }
    });
  };

  const openPatientDrawer = (userId) => {
    const u = userList.find((x) => x._id === userId);
    if (!u) return;
    setPatientDrawerUser(u);
    setPatientDrawerLoading(true);
    setPatientConsultations([]);
    setPatientQuotes([]);
    Promise.all([
      axios
        .get(`${API_BASE_URL}/api/v1/consultations`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { patient: userId, limit: 100 },
        })
        .then((consRes) => {
          const list = consRes.data?.data || consRes.data?.consultations || consRes.data || [];
          setPatientConsultations(Array.isArray(list) ? list : []);
        })
        .catch(() => setPatientConsultations([])),
      axios
        .get(`${API_BASE_URL}/api/v1/quotes/user/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((quotesRes) => {
          const q = quotesRes.data?.data || quotesRes.data || [];
          setPatientQuotes(Array.isArray(q) ? q : []);
        })
        .catch(() => setPatientQuotes([])),
    ]).finally(() => setPatientDrawerLoading(false));
  };

  const onViewClick = (id) => {
    console.log("id view", id);
    userList.forEach((item) => {
      if (item._id === id) {
        setFormData({
          _id: item._id,
          email: item.email,
          phone: item.phone,
          salutation: item.salutation,
          first_name: item.first_name,
          middle_name: item.middle_name,
          last_name: item.last_name,
          address: item.address,
          role: item.role,
          status: item.status,
          country_code: item.country_code,
          createdAt: item.createdAt,
          medicalPartnerId: medicalPartnerIdFromUser(item),
          medicalPartnerName: medicalPartnerLabelFromUser(item),
        });
        setModal({ view: true }, { add: false });
        setEditedId(item._id);
      }
    });
  };

  // function which fires on applying selected action
  const onActionClick = (id) => {
    const userToDelete = userList.find(item => item._id === id);
    if (!userToDelete) {
      swal("Error", "User not found", "error");
      return;
    }

    setShowConfirmModal({
      isOpen: true,
      type: "deleteUser",
      user: userToDelete,
      onConfirm: () => {
        performDeleteUser(id);
        setShowConfirmModal({ isOpen: false, type: null, user: null, onConfirm: null });
      },
    });
  };

  const performDeleteUser = (id) => {
    setLoading(true);
    axios
      .delete(`${API_BASE_URL}/api/v1/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        axios
          .get(`${API_BASE_URL}/api/v1/user`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: userListQueryParams,
          })
          .then((response) => {
            const rows = response.data.data || [];
            setUserList(rows);
            setData(rows);
          });
        swal("Success", "User deleted successfully", "success");
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
        const apiMsg =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Failed to delete user";
        swal("Cannot delete user", apiMsg, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // eslint-disable-next-line no-unused-vars
  const selectorCheck = (e) => {
    let newData;
    newData = userList.map((item) => {
      item.checked = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  const { errors, register, handleSubmit } = useForm();

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = userList.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <AdminSideDrawer
        open={!!patientDrawerUser}
        onClose={() => setPatientDrawerUser(null)}
        title={patientDrawerUser ? formatUserListFullName(patientDrawerUser) : ""}
        subtitle={patientDrawerUser ? patientDrawerUser.email || "" : ""}
        footer={
          patientDrawerUser ? (
            <>
              <Button
                size="sm"
                color="primary"
                type="button"
                onClick={() => history.push(getPublicUrl(`user-details-regular/${patientDrawerUser._id}`))}
              >
                Open user profile
              </Button>
              <Button size="sm" color="light" type="button" onClick={() => setPatientDrawerUser(null)}>
                Close
              </Button>
            </>
          ) : null
        }
      >
        {patientDrawerLoading ? (
          <p className="text-soft mb-0">Loading…</p>
        ) : patientDrawerUser ? (
          <div>
            <h6 className="overline-title text-soft mb-2">Consultations</h6>
            {patientConsultations.length === 0 ? (
              <p className="text-soft small mb-3">No consultations found.</p>
            ) : (
              <ul className="list list-sm mb-3 ps-0" style={{ listStyle: "none" }}>
                {patientConsultations.slice(0, 25).map((c) => (
                  <li key={c._id || c.id} className="border-bottom py-2">
                    <div className="d-flex justify-content-between flex-g-2">
                      <span className="text-break">{c.status || "—"}</span>
                      <a
                        href="#tc"
                        className="link link-sm"
                        onClick={(e) => {
                          e.preventDefault();
                          const cid = c._id || c.id;
                          if (cid) history.push(getPublicUrl(`teleconsultations/${cid}`));
                        }}
                      >
                        Open
                      </a>
                    </div>
                    <div className="text-soft small">
                      {c.scheduledAt ? moment.utc(c.scheduledAt).format("DD/MM/YYYY HH:mm") + " UTC" : "—"}
                    </div>
                  </li>
                ))}
              </ul>
            )}
            <h6 className="overline-title text-soft mb-2">Quote requests</h6>
            {patientQuotes.length === 0 ? (
              <p className="text-soft small mb-0">No quote requests.</p>
            ) : (
              <ul className="list list-sm mb-0 ps-0" style={{ listStyle: "none" }}>
                {patientQuotes.slice(0, 15).map((q, i) => (
                  <li key={q._id || q.id || `q-${i}`} className="border-bottom py-2 small">
                    <span className="text-soft">{(q.status || q.state || "—").toString()}</span>
                    {q.createdAt ? (
                      <span className="d-block text-soft">{moment(q.createdAt).format("DD/MM/YYYY")}</span>
                    ) : null}
                  </li>
                ))}
              </ul>
            )}
            <p className="small text-soft mt-3 mb-0">
              Documents are attached to each consultation; open a consultation to review files.
            </p>
          </div>
        ) : null}
      </AdminSideDrawer>
      <Head
        title={
          journeyParam === "under_care" && patientsOnly
            ? "Patients under care"
            : segmentParam === "has_quote" && patientsOnly
            ? "Client accounts (quotes)"
            : segmentParam === "has_quote"
            ? "Users (quotes)"
            : teamOnly
            ? "Team"
            : patientsOnly
            ? "Client accounts"
            : "User list"
        }
      />
      <Content>
        {teamOnly ? (
          <Alert color="info" className="mb-3">
            <strong>Internal team</strong> — Accounts with role <code>admin</code> or{" "}
            <code>secondaryRoles</code> including admin.
          </Alert>
        ) : null}
        {journeyParam === "under_care" && patientsOnly ? (
          <Alert color="info" className="mb-3">
            <strong>Patients under care</strong> — The API returns only <strong>client</strong> accounts with at least one
            teleconsultation in status <strong>scheduled</strong>, <strong>paid</strong>, or <strong>completed</strong>. Invoice or
            billing history is <strong>not</strong> used for this filter.
          </Alert>
        ) : null}
        {segmentParam && segmentParam !== "has_quote" ? (
          <Alert color="warning" className="mb-3">
            <strong>Unknown segment</strong> — <code>segment={segmentParam}</code> is not supported. Only{" "}
            <code>has_quote</code> is applied on the server; the list is not narrowed by this parameter.
          </Alert>
        ) : null}
        {segmentParam === "has_quote" ? (
          <Alert color="info" className="mb-3">
            <strong>Quote activity filter</strong> — The API returns only accounts that have at least one quote request
            {patientsOnly ? " (combined with role client when that filter is set)." : "."}
          </Alert>
        ) : null}
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                {journeyParam === "under_care" && patientsOnly
                  ? "Patients under care"
                  : segmentParam === "has_quote" && patientsOnly
                  ? "Client accounts (quotes)"
                  : segmentParam === "has_quote"
                  ? "Users (quotes)"
                  : teamOnly
                  ? "Team"
                  : patientsOnly
                  ? "Client accounts"
                  : "Users"}
              </BlockTitle>
              <BlockDes className="text-soft">
                <p className="mb-0">
                  {journeyParam === "under_care" && patientsOnly
                    ? `Server-filtered care journey: ${userList.length} row(s) in this view.`
                    : segmentParam === "has_quote"
                    ? `Server-filtered by quote activity: ${userList.length} row(s).`
                    : teamOnly
                    ? `Internal team: ${userList.length} row(s).`
                    : patientsOnly
                    ? `Role client: ${userList.length} row(s). Open Users (no role filter) for the full directory.`
                    : `You have ${userList.length} user(s) in this view.`}
                </p>
                <p className="mb-0 mt-1 small">
                  Sorting uses column headers (server-side). Display name order follows <code>last_name</code> then{" "}
                  <code>first_name</code>.
                </p>
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <DataTable className="card-stretch" scrollable>
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools mr-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    <button className="btn btn-primary" onClick={() => setModal({ add: true })}>
                      Add New User
                    </button>
                  </ul>
                </div>
              </div>
              <div className={`card-search search-wrap ${!onSearch && "active"}`}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by email or display name"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody compact>
              <DataTableHead>
                {/* <DataTableRow className="nk-tb-col-check">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input form-control"
                      onChange={(e) => selectorCheck(e)}
                      id="uid"
                    />
                    <label className="custom-control-label" htmlFor="uid"></label>
                  </div>
                </DataTableRow> */}

                <DataTableRow size="lg">
                  <span className="sub-text">User ID</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <button
                    type="button"
                    className="btn btn-link sub-text p-0 text-decoration-none text-start"
                    onClick={() => cycleSortQuery(USER_LIST_SORT.emailAsc, USER_LIST_SORT.emailDesc)}
                  >
                    Email
                    {sortCaret(activeSortParam, USER_LIST_SORT.emailAsc, USER_LIST_SORT.emailDesc)}
                  </button>
                </DataTableRow>
                <DataTableRow size="lg">
                  <button
                    type="button"
                    className="btn btn-link sub-text p-0 text-decoration-none text-start"
                    onClick={() => cycleSortQuery(USER_LIST_SORT.phoneAsc, USER_LIST_SORT.phoneDesc)}
                  >
                    Phone
                    {sortCaret(activeSortParam, USER_LIST_SORT.phoneAsc, USER_LIST_SORT.phoneDesc)}
                  </button>
                </DataTableRow>
                <DataTableRow size="lg">
                  <button
                    type="button"
                    className="btn btn-link sub-text p-0 text-decoration-none text-start"
                    onClick={() => cycleSortQuery(USER_LIST_SORT.nameAsc, USER_LIST_SORT.nameDesc)}
                  >
                    Display name
                    {sortCaret(activeSortParam, USER_LIST_SORT.nameAsc, USER_LIST_SORT.nameDesc)}
                  </button>
                </DataTableRow>
                {/* <DataTableRow size="lg">
                  <span className="sub-text">Address</span>
                </DataTableRow> */}
                {!patientsOnly && (
                  <DataTableRow size="lg">
                    <button
                      type="button"
                      className="btn btn-link sub-text p-0 text-decoration-none text-start"
                      onClick={() => cycleSortQuery(USER_LIST_SORT.roleAsc, USER_LIST_SORT.roleDesc)}
                    >
                      Role
                      {sortCaret(activeSortParam, USER_LIST_SORT.roleAsc, USER_LIST_SORT.roleDesc)}
                    </button>
                  </DataTableRow>
                )}
                <DataTableRow size="lg">
                  <span className="sub-text">Medical partner</span>
                </DataTableRow>
                {/* <DataTableRow size="lg">
                  <span className="sub-text">Status</span>
                </DataTableRow> */}
                <DataTableRow size="lg">
                  <span className="sub-text">Date</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-tools text-right"></DataTableRow>
              </DataTableHead>
              {/*Head*/}
              {currentItems.length > 0
                ? currentItems.map((item, index) => {
                    const fullName = formatUserListFullName(item);
                    const phoneInfo = formatUserListPhone(item);
                    return (
                      <DataTableItem key={item._id || item.id || `user-${index}`}>
                        <DataTableRow size="lg" dataLabel="User ID">
                          <span>{item._id}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Email">
                          <span>{item.email}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Phone">
                          <span>
                            {phoneInfo.href ? (
                              <a href={`tel:${phoneInfo.href}`}>{phoneInfo.text}</a>
                            ) : (
                              phoneInfo.text
                            )}
                          </span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Display name">
                          <span className="d-inline-flex align-items-center gap-1 flex-wrap">
                            <span>{fullName}</span>
                            {item?.hasSecondOpinionCase ? (
                              <span
                                className="badge bg-primary"
                                title="This account has at least one second-opinion case"
                              >
                                Second opinion
                              </span>
                            ) : null}
                          </span>
                        </DataTableRow>
                        {/* <DataTableRow size="lg">
                          <span>{item.address}</span>
                        </DataTableRow> */}
                        {!patientsOnly && (
                          <DataTableRow size="lg" dataLabel="Role">
                            <span>
                              {item?.role}
                              {Array.isArray(item?.secondaryRoles) && item.secondaryRoles.length
                                ? ` (+${item.secondaryRoles.join(", ")})`
                                : ""}
                            </span>
                          </DataTableRow>
                        )}
                        <DataTableRow size="lg" dataLabel="Medical partner">
                          {(() => {
                            if (patientsOnly && item?.hasSecondOpinionCase) {
                              return (
                                <Link to={getPublicUrl("second-opinion/cases")}>
                                  Second opinion cases
                                </Link>
                              );
                            }
                            const pid = medicalPartnerIdFromUser(item);
                            const plabel = medicalPartnerLabelFromUser(item);
                            if (pid) {
                              return (
                                <Link to={getPublicUrl(`medical-partner-details/${pid}`)}>
                                  {plabel || "View partner"}
                                </Link>
                              );
                            }
                            if (item?.role === "medical_partner") {
                              return (
                                <span className="badge bg-warning text-dark" title="User has medical_partner role but no medicalPartnerId">
                                  Not linked
                                </span>
                              );
                            }
                            return <span className="text-soft">—</span>;
                          })()}
                        </DataTableRow>
                        {/* <DataTableRow size="lg">
                          <span>{item.status}</span>
                        </DataTableRow> */}
                        <DataTableRow size="lg" dataLabel="Date">
                          <span>{item.createdAt ? moment(item.createdAt).format("DD/MM/YY") : "—"}</span>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-tools" dataLabel="Actions">
                          <ul className="nk-tb-actions gx-1">
                            <li className="nk-tb-action-hidden">
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={`view-${item._id}`}
                                icon="eye"
                                direction="top"
                                text="View"
                                onClick={(e) => {
                                  e.preventDefault();
                                  onViewClick(item._id);
                                }}
                              />
                            </li>
                            {patientsOnly ? (
                              <li className="nk-tb-action-hidden">
                                <TooltipComponent
                                  tag="a"
                                  containerClassName="btn btn-trigger btn-icon"
                                  id={`patient-${item._id}`}
                                  icon="activity"
                                  direction="top"
                                  text="Patient summary"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    openPatientDrawer(item._id);
                                  }}
                                />
                              </li>
                            ) : null}
                            <li className="nk-tb-action-hidden">
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={`edit-${item._id}`}
                                icon="edit-alt-fill"
                                direction="top"
                                text="Edit"
                                onClick={(e) => {
                                  e.preventDefault();
                                  onEditClick(item._id);
                                }}
                              />
                            </li>
                            {canDeleteUser ? (
                              <li className="nk-tb-action-hidden">
                                <TooltipComponent
                                  tag="a"
                                  containerClassName="btn btn-trigger btn-icon"
                                  id={`delete-${item._id}`}
                                  icon="delete"
                                  direction="top"
                                  text="Delete"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onActionClick(item._id);
                                  }}
                                />
                              </li>
                            ) : null}
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li key={`view-${item._id}`} onClick={() => onViewClick(item._id)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#view"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="eye"></Icon>
                                        <span>View</span>
                                      </DropdownItem>
                                    </li>
                                    <li key={`edit-${item._id}`} onClick={() => onEditClick(item._id)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#edit"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="edit"></Icon>
                                        <span>Edit</span>
                                      </DropdownItem>
                                    </li>
                                    {canDeleteUser ? (
                                      <li key={`delete-${item._id}`} onClick={() => onActionClick(item._id)}>
                                        <DropdownItem
                                          tag="a"
                                          href="#delete"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                          }}
                                        >
                                          <Icon name="delete"></Icon>
                                          <span>Delete </span>
                                        </DropdownItem>
                                      </li>
                                    ) : null}
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={userList.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
        {/* -----------------------user details view modal-------------------------- */}
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">User Details</h5>
              <div className="mt-4">
                <Form className="row gy-4">
                  <input type="hidden" value={formData._id} name="_id" />
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Salutation</label>
                      <p>{displayScalar(formData?.salutation)}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <p>{displayScalar(formData?.first_name)}</p>
                    </FormGroup>
                  </Col>
                  {/* <Col md="4">
                    <FormGroup>
                      <label className="form-label">Middle Name</label>
                      <p>{formData.middle_name}</p>
                    </FormGroup>
                  </Col> */}
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <p>{displayScalar(formData?.last_name)}</p>
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Email</label>
                      <p>{displayScalar(formData?.email)}</p>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Phone</label>
                      <p>
                        {(() => {
                          const { text, href } = formatUserListPhone(formData);
                          return href ? <a href={`tel:${href}`}>{text}</a> : text;
                        })()}
                      </p>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Role</label>
                      <p>{displayScalar(formData?.role)}</p>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Medical partner</label>
                      <p>
                        {formData.medicalPartnerId ? (
                          <Link to={getPublicUrl(`medical-partner-details/${formData.medicalPartnerId}`)}>
                            {formData.medicalPartnerName || "View partner"}
                          </Link>
                        ) : formData.role === "medical_partner" ? (
                          <span className="badge bg-warning text-dark">Not linked</span>
                        ) : (
                          "—"
                        )}
                      </p>
                    </FormGroup>
                  </Col>
                  {/* <Col md="12">
                    <FormGroup>
                      <label className="form-label">Address</label>
                      <p>{formData.address}</p>
                    </FormGroup>
                  </Col> */}
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="btn btn-primary"
                        >
                          Close
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* ----------------------user details edit modal------------------------------------- */}
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Update User</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <input type="hidden" value={formData._id} name="_id" />
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-salutation">
                        Salutation
                      </label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="salutaton"
                          inputId="user-edit-salutation"
                          options={filterStatus}
                          defaultValue={{ value: formData.salutation, label: formData.salutation }}
                          onChange={(e) => setFormData({ ...formData, salutation: e.value })}
                        />
                      </div>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-first_name">
                        First Name
                      </label>
                      <input
                        id="user-edit-first_name"
                        className="form-control"
                        type="text"
                        name="first_name"
                        autoComplete="given-name"
                        aria-required="true"
                        defaultValue={formData.first_name}
                        placeholder="First Name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.first_name && <span className="invalid">{errors.first_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-last_name">
                        Last Name
                      </label>
                      <input
                        id="user-edit-last_name"
                        className="form-control"
                        type="text"
                        name="last_name"
                        autoComplete="family-name"
                        aria-required="true"
                        defaultValue={formData.last_name}
                        placeholder="Last Name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.last_name && <span className="invalid">{errors.last_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-email">
                        Email
                      </label>
                      <input
                        id="user-edit-email"
                        className="form-control"
                        type="email"
                        name="email"
                        autoComplete="email"
                        aria-required="true"
                        defaultValue={formData.email}
                        placeholder="Email"
                        ref={register({
                          required: "This field is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address",
                          },
                        })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-country-code-select">
                        Country Code
                      </label>
                      <div className="form-control-wrap">
                        <span id="user-edit-country-code-select">
                        <RSelect
                          name="country_code"
                          inputId="user-edit-country_code"
                          options={countryOptions}
                          defaultValue={{ value: formData.country_code, label: formData.country_code }}
                          onChange={(e) => setFormData({ ...formData, country_code: e.value })}
                        />
                        </span>
                      </div>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-phone">
                        Phone No
                      </label>
                      <input
                        id="user-edit-phone"
                        className="form-control"
                        type="tel"
                        name="phone"
                        autoComplete="tel"
                        aria-required="true"
                        defaultValue={formData.phone}
                        placeholder="Phone No"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-edit-role-select">
                        User&apos;s Role
                      </label>
                      <div className="form-control-wrap">
                        <span id="user-edit-role-select">
                        <RSelect
                          name="role"
                          inputId="user-edit-role"
                          options={filterRole}
                          defaultValue={{ value: formData.role, label: formData.role }}
                          onChange={(e) => setFormData({ ...formData, role: e.value })}
                        />
                        </span>
                      </div>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                    {/* <FormGroup>
                      <label className="form-label">Role</label>
                      <input
                        className="form-control"
                        type="text"
                        name="role"
                        defaultValue={formData.role}
                        placeholder="Role"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.role && <span className="invalid">{errors.role.message}</span>}
                    </FormGroup> */}
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Update User
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* ----------------------add new user modal------------------------------------- */}
        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add New User</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onAddSubmit)}>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-salutation">
                        Salutation
                      </label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="salutaton"
                          inputId="user-add-salutation"
                          placeholder="Mr. or Mrs."
                          options={filterStatus}
                          onChange={(e) => setFormData({ ...formData, salutation: e.value })}
                        />
                      </div>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-first_name">
                        First Name
                      </label>
                      <input
                        id="user-add-first_name"
                        className="form-control"
                        type="text"
                        name="first_name"
                        autoComplete="given-name"
                        aria-required="true"
                        defaultValue={formData.first_name}
                        placeholder="First Name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.first_name && <span className="invalid">{errors.first_name.message}</span>}
                    </FormGroup>
                  </Col>
                  {/* <Col md="4">
                    <FormGroup>
                      <label className="form-label">Middle Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="middle_name"
                        defaultValue={formData.middle_name}
                        placeholder="Last Name"
                        ref={register({ required: "This field is required" })}
                      />
                    </FormGroup>
                  </Col> */}
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-last_name">
                        Last Name
                      </label>
                      <input
                        id="user-add-last_name"
                        className="form-control"
                        type="text"
                        name="last_name"
                        autoComplete="family-name"
                        aria-required="true"
                        defaultValue={formData.last_name}
                        placeholder="Last Name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.last_name && <span className="invalid">{errors.last_name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-email">
                        Email
                      </label>
                      <input
                        id="user-add-email"
                        className="form-control"
                        type="email"
                        name="email"
                        autoComplete="email"
                        aria-required="true"
                        defaultValue={formData.email}
                        placeholder="Email"
                        ref={register({
                          required: "This field is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address",
                          },
                        })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-country_code">
                        Country Code
                      </label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="country_code"
                          inputId="user-add-country_code"
                          options={countryOptions}
                          onChange={(e) => setFormData({ ...formData, country_code: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-phone">
                        Phone No
                      </label>
                      <input
                        id="user-add-phone"
                        className="form-control"
                        type="tel"
                        name="phone"
                        autoComplete="tel"
                        aria-required="true"
                        defaultValue={formData.phone}
                        placeholder="Phone No"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col>
                  {/* <Col md="12">
                    <FormGroup>
                      <label className="form-label">Address</label>
                      <input
                        className="form-control"
                        type="text"
                        name="address"
                        defaultValue={formData.address}
                        placeholder="Address"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.address && <span className="invalid">{errors.address.message}</span>}
                    </FormGroup>
                  </Col> */}
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label" htmlFor="user-add-role">
                        User&apos;s Role
                      </label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="role"
                          inputId="user-add-role"
                          options={filterRole}
                          onChange={(e) => setFormData({ ...formData, role: e.value })}
                        />
                      </div>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                    {/* <FormGroup>
                      <label className="form-label">User's Role</label>
                      <input
                        className="form-control"
                        type="text"
                        name="role"
                        defaultValue={formData.role}
                        placeholder="User's role"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.role && <span className="invalid">{errors.role.message}</span>}
                    </FormGroup> */}
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Add User
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* Confirm Modal for Delete */}
        <ConfirmModal
          isOpen={showConfirmModal.isOpen}
          onClose={() => setShowConfirmModal({ isOpen: false, type: null, user: null, onConfirm: null })}
          onConfirm={showConfirmModal.onConfirm || (() => {})}
          title="Delete user?"
          message={
            showConfirmModal.user
              ? `Are you sure you want to delete user "${showConfirmModal.user.first_name || ''} ${showConfirmModal.user.last_name || ''} (${showConfirmModal.user.email || 'N/A'})"?\n\nThis action cannot be undone.`
              : "Are you sure you want to delete this user?"
          }
          confirmText="Delete"
          cancelText="Cancel"
          type="danger"
          loading={loading}
        />
      </Content>
    </React.Fragment>
  );
};
export default UserListCompact;
